export const FormStatusId = {
  APPROVE: 1,
  PENDING: 2,
  CANCEL: 3,
}
